import { toast } from "react-hot-toast";

/**
 * Standardized success toast notification
 * @param {string} message 
 */
export const showSuccessToast = (message) => {
  toast.success(message || "Operation completed successfully!", {
    duration: 3500,
    position: "top-right",
  });
};

/**
 * Standardized error toast notification
 * @param {string|Error} error 
 */
export const showErrorToast = (error) => {
  const message = typeof error === "string" ? error : error?.message || "Something went wrong!";
  toast.error(message, {
    duration: 4000,
    position: "top-right",
  });
};

/**
 * Standardized warning toast notification
 * @param {string} message 
 */
export const showWarningToast = (message) => {
  toast(message || "Please check your inputs!", {
    icon: "⚠️",
    duration: 3500,
    position: "top-right",
    style: {
      border: "1px solid #FCD34D",
      padding: "12px 16px",
      color: "#92400E",
      background: "#FEF3C7",
    },
  });
};

/**
 * Standardized info toast notification
 * @param {string} message 
 */
export const showInfoToast = (message) => {
  toast(message || "Notice!", {
    icon: "ℹ️",
    duration: 3500,
    position: "top-right",
  });
};